import React from 'react';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconChartWithLegend from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconChartWithLegend';
import { AtlasV2TrafficTopSection } from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TotalTrafficTopSection';
import AtlasV2TotalTrafficTopEntity from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TotalTrafficTopEntity';
import AtlasV2TotalTrafficShareByKeyword from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TotalTrafficShareByKeyword';
import AtlasV2TotalTrafficKeywordCount from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TotalTrafficKeywordCount';
import AtlasV2TrafficProductTable from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TrafficProductTable';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas V2 Total Page layout - Tab name: traffic subtab name: totalclicks
 */
export const AtlasV2TotalTrafficPageLayout = () => {
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <BeaconChartWithLegend title="Traffic" showExportMenu={false}>
          {/* DONUT CHART and MINI SPLINE CHART */}
          <AtlasV2TrafficTopSection />
        </BeaconChartWithLegend>
        {/* TOTAL TRAFFIC WITH DROPDOWN LIST */}
        <AtlasV2TotalTrafficTopEntity />
        {/* TOTAL TRAFFIC SHARE */}
        <AtlasV2TotalTrafficShareByKeyword />
        {/* KEYWORD COUNT WITH TOTAL TRAFFIC */}
        <AtlasV2TotalTrafficKeywordCount />
        {/* TOTAL TRAFFIC PRODUCT GRID */}
        <AtlasV2TrafficProductTable subtab="totalClicks" />
      </Flex>
    </BasePageContainer>
  );
};
